import { SxProps, Theme } from "@mui/material";

export const modalStyles: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "90%" },
  maxWidth: 600,
  maxHeight: { xs: "95vh", sm: "90vh" },
  borderRadius: { xs: 2, sm: 3 },
  boxShadow: 24,
  outline: "none",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export const headerStyles: SxProps<Theme> = {
  pb: 1,
  px: { xs: 2, sm: 3 },
  pt: { xs: 2, sm: 3 },
  flexShrink: 0,
};

export const contentStyles: SxProps<Theme> = {
  pt: 2,
  px: { xs: 2, sm: 3 },
  flex: 1,
  overflow: "auto",
  minHeight: 0,
};

export const messageContentBoxStyles = (theme: Theme): SxProps<Theme> => ({
  mb: { xs: 2, sm: 3 },
});

export const messageContentTextStyles = (theme: Theme): SxProps<Theme> => ({
  p: 2,
  bgcolor:
    theme.palette.mode === "dark"
      ? theme.palette.grey[800]
      : theme.palette.grey[50],
  color: theme.palette.text.primary,
  borderRadius: 1,
  border: `1px solid ${theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[200]}`,
  maxHeight: 200,
  overflow: "auto",
});

export const formControlStyles: SxProps<Theme> = {
  mb: { xs: 2, sm: 3 },
};

export const actionsBoxStyles: SxProps<Theme> = {
  p: { xs: 2, sm: 3 },
  pt: 1,
  display: "flex",
  justifyContent: "flex-end",
  gap: { xs: 1, sm: 2 },
  flexShrink: 0,
  borderTop: "1px solid",
  borderColor: "divider",
  backgroundColor: "background.paper",
};

export const submitButtonStyles = (theme: Theme): SxProps<Theme> => ({
  bgcolor: theme.palette.error.main,
  color:
    theme.palette.mode === "dark"
      ? "#ffffff"
      : theme.palette.error.contrastText,
  "&:hover": {
    bgcolor: theme.palette.error.dark,
  },
});

export const selectStyles = (theme: Theme): SxProps<Theme> => ({
  "& .MuiSelect-select": {
    [theme.breakpoints.down("sm")]: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
});

export const feedbackFieldsContainerStyles = (
  theme: Theme,
): SxProps<Theme> => ({
  mt: 2,
  pt: 1,
  "& .MuiInputBase-input, & .MuiInputBase-inputMultiline": {
    fontSize: { xs: "16px", sm: "1rem" },
  },
});

export const labelStyles: SxProps<Theme> = {
  display: "block",
  mb: 0.5,
  color: "text.secondary",
  fontSize: "0.875rem",
  fontWeight: 500,
};

export const menuPaperStyles = (theme: Theme): SxProps<Theme> => ({
  mt: 0.5,
  borderRadius: 2,
  boxShadow: theme.shadows[8],
  border: `1px solid ${theme.palette.divider}`,
  bgcolor: theme.palette.background.paper,
  maxHeight: "min(60vh, 420px)",
  overflow: "auto",
  "& .MuiMenuItem-root": {
    fontSize: "0.9375rem",
    py: 1.25,
    px: 2,
    whiteSpace: "normal",
  },
  [theme.breakpoints.down("sm")]: {
    maxHeight: "60vh",
    "& .MuiMenuItem-root": {
      whiteSpace: "nowrap",
      overflow: "auto",
      fontSize: "0.875rem",
      padding: theme.spacing(1, 2),
      "&::-webkit-scrollbar": {
        height: 4,
      },
      "&::-webkit-scrollbar-track": {
        background: theme.palette.grey[100],
        borderRadius: 2,
      },
      "&::-webkit-scrollbar-thumb": {
        background: theme.palette.grey[400],
        borderRadius: 2,
        "&:hover": {
          background: theme.palette.grey[600],
        },
      },
    },
  },
});
